/**
 * We cannot reach into perfkit and use it directly because we load perfkit
 * lazily and it won't be accessible for some of the early timestamps we need
 * to collect. This matches what perfkit does.
 *
 * perfkit implementation: https://github.pie.apple.com/amp-metrics/mt-perfkit/blob/be2c3be1ccdf12b7896f8b59a336cc8775752ba7/src/system/environment.js#L37-L39
 */
export function getTimestamp(): number {
    return Date.now();
}
